/**
 * Gérer l'intéractivité du bouton login.
 *
 * @export
 * @class Login
 */
export default class Login {
    loginBtn;
    loginForm;
    isOuvert = false;
    /**
     * Créer une instance de Login.
     *
     * @param {HTMLButtonElement} loginBtn Le bouton login.
     * @param {HTMLFormElement} loginForm Le formulaire de connexion.
     * @memberof Login
     */
    constructor(loginBtn, loginForm) {
        this.loginBtn = loginBtn;
        this.loginForm = loginForm;
        this.ajouterListeners();
        if (new URLSearchParams(window.location.search).has('login')) {
            this.toggle();
        }
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof Login
     */
    ajouterListeners() {
        this.loginBtn.addEventListener("click", () => { this.toggle(); });
        window.addEventListener("click", (ev) => { this.gererClickWindow(ev); });
    }
    /**
     * Ouvrir — ou fermer — le formulaire de connexion.
     *
     * @public
     * @memberof Login
     */
    toggle() {
        if (this.isOuvert) {
            this.loginForm.style.display = 'none';
        }
        else {
            this.loginForm.style.display = 'flex';
        }
        this.isOuvert = !this.isOuvert;
    }
    /**
     * Gérer un click sur la fenêtre.
     *
     * @private
     * @memberof Login
     * @param ev MouseEvent
     */
    gererClickWindow(ev) {
        if (!this.isOuvert) {
            return;
        }
        if (!(ev.target instanceof Node)) {
            return;
        }
        if (this.loginBtn.contains(ev.target) ||
            this.loginForm.contains(ev.target)) {
            return;
        }
        this.loginForm.style.display = 'none';
        this.isOuvert = false;
    }
}
